import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Home } from "./Components/Home";
import Services from "./Components/Services";
import { Books } from "./Components/Books";
import { Contact } from "./Components/Contact";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import AboutAstrologer from "./Components/About-Astrologer";
import NotFoundPage from "./Components/404Page";
import OnlineConsultBanner from "./Components/OnlineConsultBanner";
// import AboutUs from "./Components/AboutUs"; // if it's in a separate file
import { FaWhatsapp, FaPhone, FaArrowAltCircleUp } from "react-icons/fa";

function App() {
  const [language, setLanguage] = useState("hindi");
  const [showTopButton, setShowTopButton] = useState(false);
  const phoneNumber = "9827504751";

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(window.scrollY > 100); // Show after scrolling 100px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <OnlineConsultBanner language={language} setLanguage={setLanguage} />
      <Navbar />

      <div className="min-h-screen bg-cover bg-center text-white transition-all duration-300">
        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/services" element={<Services language={language} />} />
          <Route path="/books" element={<Books language={language} />} />
          <Route path="/contact" element={<Contact language={language} />} />
          <Route path="/about-astrologer" element={<AboutAstrologer language={language} />} />
          <Route path="/talk-to-astrologer-" element={<AboutAstrologer language={language} />} />
          {/* <Route path="/about-us" element={<AboutUs language={language} setLanguage={setLanguage} />} /> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>

      {/* Floating Buttons */}
      <div className="fixed bottom-4 right-4 z-40 flex flex-col items-end gap-4">
      {showTopButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-44 right-6 bg-amber-800 hover:bg-yellow-900 text-white px-3 py-2 flex flex-col items-center rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 mb-20 mr-2"
        >
          <FaArrowAltCircleUp className="text-2xl mb-1" />
          <span className="text-xs font-medium">Top</span>
        </button>
      )}

        <a
          href={`https://wa.me/${phoneNumber}?text=🔮✨ *नमस्ते आचार्य जी*, मैं आपकी ज्योतिषीय सेवाओं का लाभ उठाना चाहता हूँ और मार्गदर्शन प्राप्त करना चाहता हूँ। कृपया मेरी सहायता करें। 🙏`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white text-3xl p-4 rounded-full shadow-lg transition-transform transform hover:scale-110 animate-bounce mr-2"
        >
          <FaWhatsapp />
        </a>

        <a
          href={`tel:${phoneNumber}`}
          className="bg-blue-500 hover:bg-blue-600 text-white text-3xl p-4 rounded-full shadow-lg transition-transform transform hover:scale-110 animate-bounce mb-20 mr-2"
        >
          <FaPhone />
        </a>
      </div>

      <Footer />
    </>
  );
}

export default App;
